import React, { PureComponent } from 'react'
import moment from 'moment'
import { URIS } from '../../Uris'
import { ENV } from '../../environment'

import { money, grant, generateUrl } from '../Utils/Service'

class BalanceDetails extends PureComponent {
  render() {
    const b = this.props.balance
    return (
      <ul className={'row-item ' + b.color}>
        <li>
          <span>Data</span>
          {moment.unix(b.emission_date).format('ll')}
        </li>
        <li>
          {!b.editable && <span>Intestata a</span>}
          {b.editable && <span>Emessa da</span>}
          {b.emitter}
        </li>
        <li>
          <span>causale</span>
          {b.causal}
        </li>
        <li className={'info-amount ' + (b.direction === 0 ? 'red' : 'green')}>
          <span>Importo</span>

          <div>
            {money(b.amount)}{' '}
            {b.payment_mode.toLowerCase() === 'banca' && (
              <i className='fas fa-university'></i>
            )}
            {b.payment_mode.toLowerCase() === 'contanti' && (
              <i className='fas fa-money-bill-wave'></i>
            )}
            {b.payment_mode.toLowerCase() === 'paypal' && (
              <i className='fab fa-paypal'></i>
            )}
          </div>
        </li>
        <li className='info-buttons'>
          {!b.editable && (
            <a
              href={generateUrl(ENV.production, URIS.pdf, b.id, b.checksum)}
              className='lnk-edits'
              target='_blank'
              title='Ricevuta'
            >
              <i className='fas fa-file-pdf'></i>
            </a>
          )}
          {b.editable && b.checksum !== '' && (
            <a
              href={generateUrl(ENV.production, URIS.doc, b.id, b.checksum)}
              className='lnk-edits'
              target='_blank'
              title='Fattura'
            >
              <i className='fas fa-file-alt'></i>
            </a>
          )}
          {b.editable && grant() && (
            <button
              className='lnk-edits'
              onClick={() => this.props.showEdit(b)}
            >
              <i className='fas fa-edit'></i>
            </button>
          )}
          {b.editable && grant() && (
            <button
              className='lnk-edits'
              onClick={() => this.props.showDelete(b)}
            >
              <i className='fas fa-trash-alt'></i>
            </button>
          )}
        </li>
      </ul>
    )
  }
}

export default BalanceDetails



// WEBPACK FOOTER //
// ./src/components/Balance/BalanceDetails.js